export function getRoute(locale?: string) {
  const trimmedLocale = locale?.replaceAll('/', '')
  return (path: string) => {
    const trimmedPath = path.startsWith('/') ? path.replace('/', '') : path
    return `${trimmedLocale ? `/${trimmedLocale}` : ''}/${trimmedPath}`
  }
}
